/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Topical_Weary_Starfish_EndureInputs */

const fr_topical_weary_starfish_endure = /** @type {(inputs: Topical_Weary_Starfish_EndureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Installer le site`)
};

/**

* @param {Topical_Weary_Starfish_EndureInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const topical_weary_starfish_endure = /** @type {((inputs?: Topical_Weary_Starfish_EndureInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Topical_Weary_Starfish_EndureInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_topical_weary_starfish_endure(inputs)
});